// extracted by mini-css-extract-plugin
export var active = "_5p-1";
export var activeSubdued = "_5p-2";
export var compact = "_5p-3";
export var pulse = "_5p-4";
export var settingHighlightPulse = "_5p-5";
export var wrapper = "_5p-0";